<span [formGroup]="form">
<input
	type="radio"
	(keydown.enter)="!instantChange? updateModel(value, $event) : null"
	(keydown.space)="!instantChange? updateModel(value, $event) : null"
	(change)="instantChange? updateModel(value, $event) : null"
	[value]="value"
	[attr.name]="name"
	[id]="id"
	[required]="required"
	[checked]="model == value"
	[attr.aria-selected]="model == value? 'true' : 'false'"
	[class]="class"
	[formControlName]="name"
	[attr.aria-controls]="ariaControls"
	[attr.aria-describedby]="ariaDescribedBy"
	[attr.disabled]="disabled? 'disabled' : null"
>
<label class="radio" [for]="id" [title]="labelTitle" (pointerdown)="!instantChange? updateModel(value, $event) : null" (keydown.enter)="!instantChange? updateModel(value, $event) : null">
    <span *ngIf="hasRecommendation" class="recommendation">{{ recommendationLabel | translate }}</span>
    <i [class]="icon" *ngIf="icon"></i><payment-icons *ngIf="svgIcon" [icon]="svgIcon"></payment-icons><span [innerHTML]="label"></span>
</label>
</span>
